/* eslint-disable no-redeclare */
import { USAStateAcronym } from '@hc-frontend/core-types';
import { IHttpRequest } from '@hc-frontend/core-utils-net';
import { IHttpCall } from '@hc-frontend/core-utils-net';
import { z } from 'zod';

export const GetIncomeFromFplRequestDto = z.object({
  HouseHoldSize: z.number(),
  FplList: z.array(z.number()),
  State: USAStateAcronym,
});

export type GetIncomeFromFplRequestDto = z.infer<
  typeof GetIncomeFromFplRequestDto
>;

export const GetIncomeFromFplResponseDto = z.object({
  isSuccess: z.boolean(),
  message: z.string(),
  data: z.record(z.string(), z.number()),
});

export type GetIncomeFromFplResponseDto = z.infer<
  typeof GetIncomeFromFplResponseDto
>;

export type GetIncomeFromFplOptions = Partial<
  Omit<IHttpRequest<void>, 'body'>
> & {
  httpCall?: IHttpCall;
};
